import React from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { ErrorField, StyledSubmitField, StyledForm, Field, StyledInput } from './ManageDiscountCode.styles';
import Label from '../../components/ui/Label';

const SearchDiscountCodeByDateForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState, setError } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  const onSubmit = (data) => {
    if (data && !data.validTravelDate && !data.validSalesDate) {
      setError('neitherDates', { type: 'validate', message: 'neitherDates' });

      return;
    }

    onSubmitSearch(data);
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Field>
        <Label htmlFor="validTravelDate">
          <FormattedMessage id="discountCodes.validTravelDate" />
        </Label>
        <StyledInput type="date" id="validTravelDate" {...register('validTravelDate', { required: false })} />
      </Field>

      <Field>
        <Label htmlFor="validSalesDate">
          <FormattedMessage id="discountCodes.validSalesDate" />
        </Label>
        <StyledInput type="date" id="validSalesDate" {...register('validSalesDate', { required: false })} />
      </Field>

      <StyledSubmitField>
        <ActionButton data-cy="recipient-email-search" type="submit">
          <FormattedMessage id="vouchers.search" />
        </ActionButton>
      </StyledSubmitField>

      {errors.neitherDates && (
        <ErrorField id="error-dates">
          <FormattedMessage id="discountCodes.validators.neitherDates" />
        </ErrorField>
      )}
    </StyledForm>
  );
};

SearchDiscountCodeByDateForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchDiscountCodeByDateForm;
